import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './components/Home';
import People from './components/People';
import Network from './components/Network';
import Programs from './components/Programs';
import News from './components/News';
import Submit from './components/Submit';
import Contact from './components/Contact';
import Admin from './components/Admin';
import ScheduleText from './components/ScheduleText';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function getDefaultLanguage() {
  const browserLang = navigator.language || navigator.userLanguage || 'en';
  return browserLang.toLowerCase().startsWith('zh') ? 'zh' : 'en';
}

function Layout({ language, setLanguage, children }) {
  return (
    <>
      <Navigation language={language} onLanguageChange={setLanguage} />
      <main className="app-main-content">{children}</main>
    </>
  );
}

function App() {
  const [language, setLanguage] = useState(getDefaultLanguage);

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <div className="scanlines"></div>
        <div className="crt-effect"></div>
        <div className="crt-swipe"></div>

        <Routes>
          <Route
            path="/"
            element={
              <Layout language={language} setLanguage={setLanguage}>
                <Home language={language} />
              </Layout>
            }
          />
          <Route
            path="/programs"
            element={
              <Layout language={language} setLanguage={setLanguage}>
                <Programs language={language} />
              </Layout>
            }
          />
          <Route
            path="/news"
            element={
              <Layout language={language} setLanguage={setLanguage}>
                <News language={language} />
              </Layout>
            }
          />
          <Route
            path="/schedule"
            element={<Navigate to="/scheduletext" replace />}
          />
          <Route
            path="/scheduletext"
            element={
              <Layout language={language} setLanguage={setLanguage}>
                <ScheduleText language={language} />
              </Layout>
            }
          />
          <Route
            path="/people"
            element={
              <Layout language={language} setLanguage={setLanguage}>
                <People language={language} />
              </Layout>
            }
          />
          <Route
            path="/network"
            element={
              <Layout language={language} setLanguage={setLanguage}>
                <Network language={language} />
              </Layout>
            }
          />
          <Route
            path="/submit"
            element={
              <Layout language={language} setLanguage={setLanguage}>
                <Submit language={language} />
              </Layout>
            }
          />
          <Route
            path="/contact"
            element={
              <Layout language={language} setLanguage={setLanguage}>
                <Contact language={language} />
              </Layout>
            }
          />
          <Route
            path="/adminsubmit"
            element={
              <Layout language={language} setLanguage={setLanguage}>
                <Submit
                  language={language}
                  previewMode={true}
                  countdownTarget="2027-04-10T23:59:00+08:00"
                />
              </Layout>
            }
          />
          <Route
            path="/admin"
            element={
              <Layout language={language} setLanguage={setLanguage}>
                <Admin language={language} />
              </Layout>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
